const COLLECTION_VIEW_KEY = 'collection-view';
const ALT_BODY_CLASS = 'template-collection--alt';

class CollectionView extends HTMLElement {
  connectedCallback() {
    const view = localStorage.getItem(COLLECTION_VIEW_KEY) || '';
    this.applyView(view);

    this.querySelectorAll('[data-collection-view]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const view = btn.dataset.collectionView;
        localStorage.setItem(COLLECTION_VIEW_KEY, view);
        this.applyView(view);
      });
    });
  }

  applyView(view) {
    document.body.classList.toggle(ALT_BODY_CLASS, view === 'alt');
    this.querySelectorAll('[data-collection-view]').forEach((btn) => {
      const isActive = btn.dataset.collectionView === view;
      btn.classList.toggle('collection-layout__button--active', isActive);
      btn.classList.toggle('opacity-100', isActive);
      btn.classList.toggle('opacity-25', !isActive);
    });
  }
}

if (!customElements.get('collection-view')) {
  customElements.define('collection-view', CollectionView);
}
